import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-gray" data-id="element-80">
      <div className="bg-white border-2 border-brand-pool p-5 rounded-lg text-center shadow-md" data-id="element-81">
        <p className="text-xs font-bold text-brand-orange uppercase tracking-widest mb-3" data-id="element-82">
          YOUR INVESTMENT IS 100% PROTECTED
        </p>
        <div className="w-14 h-14 mx-auto bg-brand-pool/10 rounded-full flex items-center justify-center mb-3" data-id="element-83">
          <ShieldCheck className="w-7 h-7 text-brand-pool" data-id="element-84" />
        </div>
        <h3 className="text-xl font-heading font-black text-brand-navy mb-2 uppercase leading-tight" data-id="element-85">
          🛡️ 7-Day Total Guarantee
        </h3>
        <p className="text-sm font-bold text-brand-navy mb-3 uppercase tracking-wide" data-id="element-86">
          Your money is 100% protected.
        </p>
        <p className="text-sm text-brand-navy/80 leading-snug" data-id="element-87">
          You have 7 full days to explore the entire system, review the lessons,
          implement the programming, and evaluate the results with your
          swimmers. If you're not completely satisfied, we'll refund 100% of
          your money. Zero risk for you.
        </p>
      </div>
    </section>;
}